import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Text} from '@travel-frontend/core';

export const Container = styled.div(
  ({theme}) => css`
    width: 100%;
    height: 28px;
    background: linear-gradient(90deg, #e8494f, #f6ad2c);
    ${theme.isAccessibleTheme &&
    css`
      background: ${theme.colors.contentAdditionalA};
    `}
    color: ${theme.colors.contentInversePrimary};
    margin-top: 2px;

    ${Text} {
      text-transform: uppercase;
    }
  `
);
